module.exports = __webpack_public_path__ + "static/media/londonbtdp.94175dbb.jpg";